(function(){
  function ligar(){
    var pack=document.querySelector('[data-sar-pack]');
    if(!pack) return;
    function campoQtd(){
      return document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
    }
    pack.addEventListener('change',function(e){
      var op=e.target.closest('.sar-pack__op'); if(!op) return;
      var q=op.getAttribute('data-qtd');
      var c=campoQtd(); if(c){ c.value=q; c.dispatchEvent(new Event('change',{bubbles:true})); }
      pack.querySelectorAll('.sar-pack__op').forEach(function(o){o.classList.toggle('escolhido', o===op);});
    });
    var inicial=pack.querySelector('.sar-pack__op input:checked');
    if(inicial) inicial.closest('.sar-pack__op').classList.add('escolhido');
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',ligar); else ligar();
  document.addEventListener('shopify:section:load',ligar);
})();
